/**
 * マスター・用語・画面（F5）の Query キー。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 分類マスター・画面・用語の読取 procedure の Query キーを定義する。
 * @graph-connects none
 */
import type { LocaleKeyPart } from './common.js';

/**
 * 案件の面。案件を選んでいなければ `null`（master）。
 *
 * 案件モードの詳細は同じ要素を変更前（`before`）と変更後（`after`）の 2 回引く。面を鍵に
 * 載せないと 2 回の結果が同じ鍵に入り、左右に同じ姿が並ぶ。
 */
type PjSideKeyPart = 'before' | 'after' | null;

/** マスター・用語・画面の仕様グラフ読取のキー。 @graph-connects none */
export const mastersQueryKeys = {
  /*
   * 分類マスターの一覧。procedure は型ごとに分かれている（listActors / listDomains /
   * listVerbs / listUnits）ので、procedure 名をそのまま鍵の 2 段目に置く。
   */
  listMasters: (procedure: string, locale: LocaleKeyPart, pjNumber?: number) =>
    ['specGraph', procedure, pjNumber ?? null, locale ?? null] as const,
  getMasterDetail: (
    type: string,
    id: number,
    locale: LocaleKeyPart,
    pjNumber?: number,
    side: PjSideKeyPart = null,
  ) => ['specGraph', 'getMasterDetail', type, id, pjNumber ?? null, side, locale ?? null] as const,
  /* 画面の読取 2 本のキー。画面の ID と案件番号は number である。 */
  listScreens: (locale: LocaleKeyPart, pjNumber?: number) =>
    ['specGraph', 'listScreens', pjNumber ?? null, locale ?? null] as const,
  getScreenDetail: (
    screenId: number,
    locale: LocaleKeyPart,
    pjNumber?: number,
    side: PjSideKeyPart = null,
  ) => ['specGraph', 'getScreenDetail', screenId, pjNumber ?? null, side, locale ?? null] as const,
  /* 用語の読取 2 本のキー。用語の ID と案件番号は number である。 */
  listTerms: (locale: LocaleKeyPart, pjNumber?: number) =>
    ['specGraph', 'listTerms', pjNumber ?? null, locale ?? null] as const,
  getTermDetail: (
    termId: number,
    locale: LocaleKeyPart,
    pjNumber?: number,
    side: PjSideKeyPart = null,
  ) => ['specGraph', 'getTermDetail', termId, pjNumber ?? null, side, locale ?? null] as const,
} as const;
